import type { managerActions } from '@store/reducers/manager'
import axios, { type AxiosResponse } from 'axios'
import { call } from 'redux-saga/effects'

const touchReq = (id: string): Promise<AxiosResponse<any>> =>
  axios.get(`/projects/${id}/touch`, {
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
      'X-Auth-Token': localStorage.getItem('token'),
      'X-Export-Token': localStorage.getItem('export_token'),
      'X-Password-Token': localStorage.getItem(`pw_${id}`),
    },
  })

export function* touch({
  payload: { id },
}: ReturnType<typeof managerActions.touch>) {
  yield call(touchReq, id)
}
